import ApiService from './api.service'

const PlatypusService = {

  /***
   * Get items that can be added as a line-item for invoice(s)
   * @returns {array}
   */
  getOptsInvoiceItems (params) {
    return ApiService.query('platypus/get-opts-invoice-items', params)
  },
  /***
   * Get rates that can be assigned to accounts
   * @returns {array}
   */
  getOptsRateItems (params) {
    return ApiService.query('platypus/get-opts-rate-items', params)
  },
  /***
   * Query Payments
   * {
    "page": 10,
    "pageSize": 50,
    "orderBy": {
        "op": "asc",
        "value": "pmt_postdate"
    },
    "filterCustid": {
        "op": "not",
        "value": [0]
    },
    "filterPaymentDate": {
        "op": "between",
        "value": ["2020-01-01", "2020-01-15"]
    }
}

   * @returns {array}
   */
  queryPayments (params) {
    return ApiService.post('platypus/query-payments', params)
  },
}
export default PlatypusService
